
import { useAccessibilityAnnouncements } from '@/hooks/useAccessibilityAnnouncements';

export const ScreenReaderAnnouncer = () => {
  const { announcement, assertiveAnnouncement } = useAccessibilityAnnouncements();

  return (
    <>
      {/* Polite announcements - used for most updates */}
      <div
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
      >
        {announcement}
      </div>
      
      {/* Assertive announcements - used for critical updates */}
      <div
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        className="sr-only"
      >
        {assertiveAnnouncement}
      </div>
    </>
  );
};
